import {
  Checkbox,
  Dialog,
  DialogContent,
  FormControlLabel,
  MenuItem,
  Tooltip,
  Typography,
  withWidth,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Done from "@material-ui/icons/CheckBox";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import StockItemSearch from "../../Components/StockItems/StockItemSearch";
import Title from "../../Components/Title";

import { useDispatch } from "react-redux";
import {
  getToken,
  invoiceIssuers,
  requestErrorHandler,
} from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";
// import OrderLine from "../Orders/OrderLine";
import BrowseContactsDialog from "../../Components/Contacts/BrowseContactsDialog";
import DialogAppBar from "../../Components/DialogAppBar";
import NumericalInput from "../../Components/NumericalInput";
import OrderLine from "./OrderLine";

const server = EnvSettings.server;

function HeaderObject({ width }) {
  const { t } = useTranslation();
  return (
    <Grid container style={{ borderTop: "1px solid #000", padding: 5 }}>
      {width === "xs" ? null : <Grid item sm={1} xs={1}></Grid>}
      <Grid item sm={3} xs={3} style={{ padding: 5 }}>
        SKU
      </Grid>
      {width === "xs" ? null : (
        <Grid item sm={3} xs={3} style={{ padding: 5 }}>
          {t("description")}
        </Grid>
      )}
      <Grid item sm={1} xs={3} style={{ padding: 5 }}>
        {t("orders.numberItems")}
      </Grid>
      <Grid item sm={1} xs={3} style={{ padding: 5 }}>
        {t("orders.unitPrice")}
      </Grid>
      {width === "xs" ? null : <Grid item sm={1} xs={1}></Grid>}
    </Grid>
  );
}

function NewOrder({ width }) {
  const classes = useStyles();
  const [saveContact, setSaveContact] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [manualTotalPrice, setManualTotalPrice] = useState(false);
  const [currency, setCurrency] = useState("EUR");
  const [issuer, setIssuer] = useState();
  const [productFilter, setProductFilter] = useState(false);
  const [details, setDetails] = useState();
  const { t } = useTranslation();
  const [orderNumber, setOrderNumber] = useState();
  const [newProduct, setNewProduct] = useState(false);
  const [newProductCount, setNewProductCount] = useState();
  const [newProductSku, setNewProductSku] = useState();
  const [newProductName, setNewProductName] = useState();
  const [orderBuyer, setOrderBuyer] = useState();
  const [gridRef, setGridRef] = useState("ssdafasfasd");
  const [clientInfoObject, setClientInfoObject] = useState();
  const dispatch = useDispatch();

  const editClientInfo = (value, key) => {
    setClientInfoObject({ ...clientInfoObject, [key]: value });
  };

  const submitOrder = (file) => {
    if (!orderBuyer) {
      alert(t("resupplyOrders.pleaseSetBuyerCompany"));
      return;
    }
    if (!clientInfoObject || !clientInfoObject.companyId) {
      alert(t("resupplyOrders.pleaseEnterSupplierCompany"));
      return;
    }
    if (!selectedProducts || !selectedProducts.length) {
      return;
    }
    var sp = selectedProducts;
    if (newProduct && (newProductSku || newProductName) && newProductCount) {
      sp = [
        ...sp,
        { sku: newProductSku, name: newProductName, count: newProductCount },
      ];
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceList: sp,
        totalPrice: totalPrice,
        currency: currency,
        invoiceIssuer: issuer,
        details: details,
        orderNumber: orderNumber,
        orderBuyer: orderBuyer,
        orderStatus: "invoiced",
        supplierCompanyId: clientInfoObject.companyId,
        clientInfoObject: clientInfoObject,
        saveContact: saveContact,
      }),
    };
    fetch(server + "/add_resupply_order", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          window.location.reload();
        }
      });
  };

  const resetForm = () => {
    setShowForm(false);
    setSelectedProducts([]);
    setTotalPrice(0);
    setCurrency("EUR");
    setIssuer();
  };

  useState(() => {
    setOrderNumber(crypto.randomUUID());
  }, []);

  return (
    <>
      <Dialog open={showForm} fullScreen>
        <DialogContent>
          <DialogAppBar
            header={t("resupplyOrders.newResupplyOrder")}
            onClose={() => {
              setShowForm(false);
            }}
          />
          <Grid container style={{ marginTop: 60 }} spacing={3}>
            <Grid item xs={6} sm={3}>
              <BrowseContactsDialog
                setClientInfoObject={(data) => {
                  setClientInfoObject();
                  data = {
                    ...data,
                    ...data.companyAdditionalInfo,
                  };
                  // This rehreshes the form
                  setTimeout(() => {
                    setClientInfoObject(data);
                  }, 100);
                }}
                activeObject={
                  clientInfoObject &&
                  Object.values(clientInfoObject).find((v) => v !== "")
                    ? clientInfoObject
                    : undefined
                }
                resupply={true}
                label={t("resupplyOrders.orderFrom")}
              />
              {clientInfoObject &&
              JSON.stringify(clientInfoObject) !== JSON.stringify({}) ? (
                <>
                  <Tooltip
                    disableHoverListener={!clientInfoObject.companyId}
                    title={
                      <Typography style={{ fontSize: 15 }}>
                        {t("orders.editCompanyNameWarning")}
                      </Typography>
                    }
                  >
                    <TextField
                      style={{ marginTop: 5 }}
                      fullWidth
                      label={t("contactInfo.companyName")}
                      value={clientInfoObject.companyName}
                      onChange={(e) => {
                        editClientInfo(e.target.value, "companyName");
                      }}
                      disabled={!!clientInfoObject.companyId}
                    ></TextField>
                  </Tooltip>
                  <TextField
                    fullWidth
                    label={t("contactInfo.companyAddress")}
                    value={clientInfoObject.companyAddress}
                    multiline
                    rows={3}
                    onChange={(e) => {
                      editClientInfo(e.target.value, "companyAddress");
                    }}
                  ></TextField>

                  <TextField
                    fullWidth
                    label={"VAT ID"}
                    value={clientInfoObject.companyVatId}
                    onChange={(e) => {
                      editClientInfo(e.target.value, "companyVatId");
                    }}
                  ></TextField>
                  <Button
                    fullWidth
                    variant="outlined"
                    style={{ marginTop: 5 }}
                    endIcon={
                      saveContact ? <Done style={{ color: "green" }} /> : null
                    }
                    onClick={() => {
                      setSaveContact(!saveContact);
                    }}
                  >
                    {t("contactInfo.saveContactInfo")}
                  </Button>
                </>
              ) : null}
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                label={t("resupplyOrders.buyer")}
                variant="outlined"
                fullWidth
                required
                select
                onChange={(e, v) => {
                  if (e && e.target.value) {
                    setOrderBuyer(e.target.value);
                  }
                }}
              >
                {Object.keys(invoiceIssuers).map((p, i) => (
                  <MenuItem value={p} key={i}>
                    {invoiceIssuers[p].name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item container xs={12} spacing={width === "xs" ? "" : 3}>
              <Grid item xs={12}>
                <Title>{t("orders.itemSearch")}</Title>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  defaultChecked={false}
                  control={
                    <Checkbox
                      onChange={(e, v) => {
                        setProductFilter(!productFilter);
                      }}
                      defaultChecked={false}
                      color="primary"
                    />
                  }
                  label={t("orders.showOnlyFinishedProducts")}
                />
              </Grid>
              <Grid item xs={6}>
                <StockItemSearch
                  allowNewItems={false}
                  onChange={(e, v) => {
                    if (v && v.sku) {
                      setSelectedProducts([
                        ...selectedProducts,
                        { ...v, count: 1 },
                      ]);
                      if (v.costPrice) {
                        setTotalPrice((t) => t + v.costPrice);
                      }
                    }
                  }}
                  clearOnSelect={true}
                  includeQuantity={true}
                  includeTags={true}
                  includePacking={true}
                  placeholder={t("orders.startSearchingProducts")}
                  filters={
                    productFilter
                      ? {
                          Tags: ["Finished Product"],
                        }
                      : undefined
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    setNewProduct(true);
                  }}
                >
                  {t("resupplyOrders.itemNotInList")}
                </Button>
              </Grid>
              {selectedProducts.length || newProduct ? (
                <>
                  {width === "xs" ? null : (
                    <Grid item xs={12}>
                      <HeaderObject width={width} />{" "}
                    </Grid>
                  )}
                  {newProduct ? (
                    <Grid container key={gridRef}>
                      <Grid item xs={3} style={{ padding: 5 }}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          size="small"
                          label="SKU"
                          onChange={(e, v) => {
                            if (!e || !e.target.value) {
                              return;
                            }
                            setNewProductSku(e.target.value);
                          }}
                        ></TextField>
                      </Grid>
                      <Grid item xs={3} style={{ padding: 5 }}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          size="small"
                          label="Name"
                          onChange={(e, v) => {
                            if (!e || !e.target.value) {
                              return;
                            }
                            setNewProductName(e.target.value);
                          }}
                        ></TextField>
                      </Grid>
                      <Grid item xs={1}></Grid>
                      <Grid item xs={1} style={{ padding: 5 }}>
                        <TextField
                          variant="outlined"
                          type="number"
                          inputProps={{ min: 1 }}
                          label={t("count")}
                          size="small"
                          onChange={(e, v) => {
                            if (!e || !e.target.value) {
                              return;
                            }
                            setNewProductCount(Number(e.target.value));
                          }}
                        ></TextField>
                      </Grid>
                      <Grid item xs={2} style={{ padding: 5 }}>
                        <Button
                          color="primary"
                          variant="contained"
                          size="small"
                          onClick={() => {
                            if (!newProductSku && !newProductName) {
                              return;
                            }
                            setSelectedProducts([
                              ...selectedProducts,
                              {
                                sku: newProductSku,
                                name: newProductName,
                                count: newProductCount,
                                id: "new" + Math.round(Math.random() * 100),
                              },
                            ]);
                            setNewProductCount();
                            setNewProductName();
                            setNewProductSku();
                            setGridRef(Math.random());
                          }}
                        >
                          OK
                        </Button>
                      </Grid>
                      <Grid item xs={1} style={{ padding: 5 }}>
                        <Button
                          color="secondary"
                          variant="contained"
                          size="small"
                          onClick={() => {
                            setNewProduct(false);
                          }}
                        >
                          {t("cancel")}
                        </Button>
                      </Grid>
                    </Grid>
                  ) : null}
                  <Grid item xs={12}>
                    {selectedProducts.map((dev, i) => (
                      <OrderLine
                        key={i}
                        item={dev}
                        selectedProducts={selectedProducts}
                        setSelectedProducts={setSelectedProducts}
                        totalPrice={totalPrice}
                        setTotalPrice={(value) => {
                          if (manualTotalPrice) {
                            return;
                          }
                          setTotalPrice(value);
                        }}
                        width={width}
                        costPrice={true}
                      />
                    ))}
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      style={{ borderTop: "1px solid #000", paddingTop: 10 }}
                    >
                      <Grid item sm={2} xs={2}>
                        <NumericalInput
                          type="number"
                          size="small"
                          disabled={
                            manualTotalPrice
                              ? false
                              : !!selectedProducts.find((f) => f.costPrice)
                          }
                          inputProps={{ min: 0 }}
                          variant="outlined"
                          label={t("orders.totalPrice")}
                          defaultValue={totalPrice}
                          onChange={(e, v) => {
                            if (!e || !e.target) {
                              setManualTotalPrice(false);
                              return;
                            }
                            if (Number(e.target.value)) {
                              setManualTotalPrice(true);
                            } else {
                              setManualTotalPrice(false);
                            }
                            setTotalPrice(e.target.value);
                          }}
                          helperText={
                            manualTotalPrice
                              ? t(
                                  "resupplyOrders.manualTotalPrice",
                                  "Total Price set manually, unit prices are not counted",
                                )
                              : selectedProducts.find((f) => f.costPrice)
                                ? t(
                                    "resupplyOrders.totalPriceEditDisabled",
                                    "Editing disabled when unit prices have been defined for order items",
                                  )
                                : ""
                          }
                        />
                      </Grid>
                      <Grid item sm={1} xs={2}>
                        <TextField
                          select
                          value={currency}
                          onChange={(e, v) => {
                            setCurrency(e.target.value);
                          }}
                        >
                          <MenuItem key={"USD"} value={"USD"}>
                            USD
                          </MenuItem>
                          <MenuItem key={"EUR"} value={"EUR"}>
                            EUR
                          </MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              ) : null}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  rows={2}
                  multiline
                  label={t("details")}
                  variant="outlined"
                  onChange={(e, v) => {
                    if (e.target && e.target.value) {
                      setDetails(e.target.value);
                      return;
                    }
                    setDetails();
                  }}
                />
              </Grid>
            </Grid>
            <Grid item sm={6} xs={12} container spacing={1}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={submitOrder}
                >
                  {t("submit")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={resetForm}
                >
                  {t("cancel")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container spacing={3}>
            {!showForm ? (
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setShowForm(!showForm);
                  }}
                >
                  {t("orders.addNewOrder")} +
                </Button>
              </Grid>
            ) : null}
          </Grid>
        </Paper>
      </Grid>
    </>
  );
}

export default withWidth()(NewOrder);
